
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import Icon from '../assets/icons';
import { SidePanelTabs } from '../components/shared';
import { ITabs, Tabs } from '../components/tabs';
import { AppPage } from '../layouts/types';
import { RootState, AppDispatch } from '../store';
import { fetchAllLanguages, updatePreferredLanguage, changeLanguage } from '../store/reducers/language';
import ResetPassword from '../components/inputs/ResetPassword';
import Tab from '../interfaces/Tab';
import { Button } from '../components/buttons';


interface ScreenFeature {
  winWidth: number;
  winHeight?: number;
}

const LanguageScreen = () => {

  const { items: languages, preferredLanguage } = useSelector((state: RootState) => state.settings.langaguge)
  const dispatch = useDispatch<AppDispatch>();

  const languageDisplayMap: Record<string, string> = {
    English: "English",
    Hindi: "हिंदी",
    Marathi: "मराठी",
    Tamil: "தமிழ்",
    Telugu: "తెలుగు",
    Malayalam: "മലയാളം",
    Punjabi: "ਪੰਜਾਬੀ",
    Bengali: "বাংলা",
  };

  useEffect(() => {
    dispatch(fetchAllLanguages())
  }, []);

  useEffect(() => {
  if (languages.length > 0 && !preferredLanguage) {
    const english = languages.find(
      (lang) => lang.name.toLowerCase() === "english"
    );

    if (english) {
      dispatch(changeLanguage(english.id));
    }
  }
}, [languages, preferredLanguage]);

  const handleUpdatePreferredLanguage = async (languageId: number) => {
    dispatch(updatePreferredLanguage(languageId));
    toast.success("Language updated successfully");
  };

  const handleLanguageSelection = (languageId: number) => {
    dispatch(changeLanguage(languageId));
  };

  return (
    <div>
      <h2 className="text-[#545455] text-[16px] font-bold font-lato mobile:text-sm px-2">
        Set Default Language
      </h2>
      <hr className="h-[1px] bg-app-blue mb-5" />

      <div className="grid grid-cols-4 tablet:grid-cols-3 mobile:grid-cols-1 justify-between gap-4">
        {languages.map((language) => {
          const isEnglish = language.name.toLowerCase() === "english";
          const isBlurred = !isEnglish;

          return (
            <div
              key={language.id}
              className={`relative flex flex-1 items-center justify-between p-3 rounded-2xl shadow-bottom border border-1
                         ${isBlurred ? "opacity-50 grayscale cursor-not-allowed" : "hover:shadow-lg"}
                         `}
            >
              {/* <span className="text-left text-sm text-app-gray-medium font-bold space-x-2">
                {language.name}
              </span> */}
              <span className="text-left text-sm text-app-gray-medium font-bold space-x-2">
                {languageDisplayMap[language.name] || language.name}
              </span>

              <input
                type="radio"
                name="language"
             checked={language.name.toLowerCase() === "english"}
                onChange={() => !isBlurred && handleLanguageSelection(language.id)}
                className={`ml-8 h-5 w-5 rounded border outline-none hover:cursor-pointer accent-[#800080] `}
                disabled={isBlurred}
              />


            </div>
          );
        })}
      </div>

      {/* Save button*/}
      <div className="flex items-center gap-6 mt-4">
        <Button
          styles="rounded-full px-12 bg-gradient-to-r from-fuchsia-800 to-fuchsia-500 shadow-md text-white outline-none mobile:px-8 mobile:text-sm"
          onClick={() => handleUpdatePreferredLanguage(preferredLanguage as number)}
        >
          Save
        </Button>

        <span className="text-[#545455] font-lato font-bold text-[16px] tracking-wide uppercase">
          Multi-Lingual Support Launching Soon
        </span>
      </div>
    </div>
  );
};

const PasswordScreen = () => {
  const [password, setPassword] = useState("");

  const handlePasswordChange = (value: string) => {
    setPassword(value);
  };

  return (
    <>
      <ResetPassword />
    </>
  );
};

const Settings: AppPage = () => {
  const [activeTab, setActiveTab] = useState("language");
  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
  };

  const [screenWidth, setScreenWidth] = useState<ScreenFeature>({
    winWidth: 0,
    winHeight: 0,
  });

  const windowSize = () => {
    setScreenWidth({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    });
  };

  useEffect(() => {
    windowSize();
    window.addEventListener("resize", windowSize);

    return () => {
      window.removeEventListener("resize", windowSize);
    };
  }, []);

  const tabData: ITabs = {
    " Language ": [
      {
        id: 1,

        TabContent: <LanguageScreen></LanguageScreen>,
      },
    ],
    " Change Password ": [
      {
        id: 2,
        TabContent: <PasswordScreen></PasswordScreen>,
      },
    ],
  };

  const sideBarData: any[] = [
    {
      id: "language",
      label: "Language",
      icon: <img src={Icon.language} alt="vCard" width={30} height={30} />,
      content: <LanguageScreen></LanguageScreen>,
    },
    {
      id: "passwords",
      label: "Change Password",
      icon: <img src={Icon.changePWD} alt="vCard" width={30} height={30} />,
      content: <PasswordScreen></PasswordScreen>,
    },
  ];

  return (
    <div className="h-full">
      {screenWidth.winWidth < 768 || screenWidth.winWidth < 1024 ? (
        <Tabs data={tabData}></Tabs>
      ) : (
        <SidePanelTabs
          handleTabClick={handleTabClick}
          activeTab={activeTab}
          tabs={sideBarData}
          title="Settings"
        />
      )}
    </div>
  );
};

export default Settings;